/**
 * @generated SignedSource<<9bcb7ce9d79c867a9f249257c7195e5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type dataValidationRuleDetailsQuery$variables = {
  owner?: string | null;
  resourceName: string;
};
export type dataValidationRuleDetailsQuery$data = {
  readonly validationRuleDetails: {
    readonly categories: ReadonlyArray<string> | null;
    readonly checkId: number | null;
    readonly connectorComponentRef: {
      readonly kind: string | null;
      readonly name: string | null;
      readonly version: string | null;
    } | null;
    readonly containerId: number | null;
    readonly datastoreId: number | null;
    readonly description: string;
    readonly displayName: string;
    readonly generalProperties: ReadonlyArray<{
      readonly externalObjectType: string | null;
      readonly order: number | null;
      readonly placeholderText: string | null;
      readonly propertyName: string | null;
      readonly propertyValue: string | null;
      readonly propertyValues: ReadonlyArray<string | null> | null;
      readonly requiredField: boolean | null;
      readonly uiReadOnly: boolean | null;
      readonly visibility: boolean | null;
    }> | null;
    readonly notificationProperties: ReadonlyArray<{
      readonly propertyName: string;
      readonly propertyValue: string | null;
      readonly propertyValues: ReadonlyArray<string | null> | null;
    } | null> | null;
    readonly provider: string | null;
    readonly resourceName: string;
    readonly ruleLibraryItemRef: {
      readonly kind: string | null;
      readonly name: string | null;
      readonly rliType: string | null;
      readonly version: string | null;
    } | null;
    readonly specificProperties: ReadonlyArray<{
      readonly externalObjectType: string | null;
      readonly order: number | null;
      readonly placeholderText: string | null;
      readonly propertyName: string | null;
      readonly propertyValue: string | null;
      readonly propertyValues: ReadonlyArray<string | null> | null;
      readonly requiredField: boolean | null;
      readonly uiReadOnly: boolean | null;
      readonly visibility: boolean | null;
    } | null> | null;
    readonly status: string | null;
    readonly status_message: string | null;
  } | null;
};
export type dataValidationRuleDetailsQuery = {
  response: dataValidationRuleDetailsQuery$data;
  variables: dataValidationRuleDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceName"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyValues",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalObjectType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "order",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uiReadOnly",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "visibility",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requiredField",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "placeholderText",
    "storageKey": null
  }
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      },
      {
        "kind": "Variable",
        "name": "resourceName",
        "variableName": "resourceName"
      }
    ],
    "concreteType": "ValidationRuleDetails",
    "kind": "LinkedField",
    "name": "validationRuleDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resourceName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConnectorComponentRef",
        "kind": "LinkedField",
        "name": "connectorComponentRef",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RuleLibraryItemRef",
        "kind": "LinkedField",
        "name": "ruleLibraryItemRef",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rliType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categories",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status_message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationRuleProperty",
        "kind": "LinkedField",
        "name": "generalProperties",
        "plural": true,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationRuleProperty",
        "kind": "LinkedField",
        "name": "specificProperties",
        "plural": true,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RuleProperty",
        "kind": "LinkedField",
        "name": "notificationProperties",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checkId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "datastoreId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containerId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dataValidationRuleDetailsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dataValidationRuleDetailsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "c5f7906af813bee27e45faf024a214f8",
    "id": null,
    "metadata": {},
    "name": "dataValidationRuleDetailsQuery",
    "operationKind": "query",
    "text": "query dataValidationRuleDetailsQuery(\n  $owner: String\n  $resourceName: String!\n) {\n  validationRuleDetails(owner: $owner, resourceName: $resourceName) {\n    resourceName\n    displayName\n    description\n    provider\n    connectorComponentRef {\n      kind\n      name\n      version\n    }\n    ruleLibraryItemRef {\n      kind\n      name\n      version\n      rliType\n    }\n    categories\n    status\n    status_message\n    generalProperties {\n      propertyName\n      propertyValue\n      propertyValues\n      externalObjectType\n      order\n      uiReadOnly\n      visibility\n      requiredField\n      placeholderText\n    }\n    specificProperties {\n      propertyName\n      propertyValue\n      propertyValues\n      externalObjectType\n      order\n      uiReadOnly\n      visibility\n      requiredField\n      placeholderText\n    }\n    notificationProperties {\n      propertyName\n      propertyValue\n      propertyValues\n    }\n    checkId\n    datastoreId\n    containerId\n  }\n}\n"
  }
};
})();

(node as any).hash = "10e122be147aaa10da4d09caa8aaa2e3";

export default node;
